"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DynamicFormattedMessage = void 0;
var _reactIntl = require("react-intl");
var _constants = require("../internals/constants");
/**
 * A function for formatting elements within a dynamic message.
 *
 * @template T - The type of elements to format.
 * @template R - The resulting format after processing.
 * @param parts - An array of parts to format.
 * @returns The formatted result.
 */

/**
 * Props for the DynamicFormattedMessage component.
 *
 * @template V - The type of values for message formatting.
 */

/**
 * Represents a component for dynamically formatted messages using React Intl (TranslationsProvider)
 *
 * @param translatedMessage - The message to be translated. It can be a string or an array of MessageFormatElement.
 * @param values - An object containing values to be interpolated into the message.
 *
 * @returns The translated and formatted message as a ReactNode.
 */
const DynamicFormattedMessage = ({
  translatedMessage,
  values
}) => {
  const {
    formatMessage
  } = (0, _reactIntl.useIntl)();
  const message = formatMessage({
    id: `${_constants.DYNAMIC_TRANSLATION_PREFIX}${translatedMessage.toString()}`,
    defaultMessage: translatedMessage
  }, values);
  return message;
};
exports.DynamicFormattedMessage = DynamicFormattedMessage;
